<template>
    <div class="Background">
        <v-row>

            <v-col sm="12" cols="6">
                <v-row>
                    <v-col cols="12">
                    
                        <!--img-->
                        <div class="video-container">
                            <iframe scrolling="no"  ref="iframe" :src="EMBEDIEDURL" frameborder="0" allowfullscreen @load="temp"
                                @playing="resizeVideo"></iframe>
                        </div>
                    </v-col>
                </v-row>

                <div class="mt-2" style="display: flex;justify-content: space-between;">
                    <div class="suport_box">
                        <strong>새로고침 버튼을 눌러주셔야 라이브 방송이 스트림온에 반영됩니다.</strong>
                    </div>
                    <IconButton icon="mdi-refresh" class="ml-2" small @click="refresh" height="41px"/>
                </div>
            </v-col>

            <v-col sm="12" cols="6">
                <v-row>

                
                <v-col class="mr-3">
                    <h3 class="tabletitle">
                        스트리밍 상세 정보
                    </h3>
                    <v-simple-table>
                        <template>
                            <thead>
                                <tr>
                                    <th class="thead_custom_left thead_custom_top pa-3" style="height: 60px;">
                                        Live 스트리밍
                                    </th>
                                    <th class="thead_custom_right thead_custom_top pa-3">
                                        <span><Input placeholder="name" :value="stream_name" viewType="name" :disabled="true" /></span>
                                    </th>
                                </tr>
                                <tr>
                                    <th class="thead_custom_left pa-3" style="height: 66px;">
                                        퍼블리싱
                                    </th>
                                    <th class="thead_custom_right pa-3">
                                        <CustomSwitch :switchState="switchStates.publishing"
                                            :toggleSwitch="() => toggleSwitch('publishing')" />
                                    </th>
                                </tr>
                                <tr>
                                    <th class="thead_custom_left pa-3" style="height: 66px;">
                                        레코딩
                                    </th>
                                    <th class="thead_custom_right pa-3">
                                        <CustomSwitch :switchState="switchStates.recording"
                                            :toggleSwitch="() => toggleSwitch('recording')" />

                                    </th>
                                </tr>

                            </thead>
                        </template>
                    </v-simple-table>
                    <div class="text-right">
                    <TextButton buttonText="저장" class="mt-2" isPrimary @click="saveChanges" />
                </div>
                </v-col>

                

                <v-col>
                    <h3 class="tabletitle">
                        INFO
                    </h3>

                    <v-simple-table>
                        <template>
                    <thead>
                        <tr>
                            <th class="thead_custom_left thead_custom_top pa-3" style="width: 210px;">
                                <v-row>
                                    <v-col cols="8">
                                        <h4>OnpublishServer</h4>
                                    </v-col>
                                    <v-col cols="4">
                                        <TextButton buttonText="copy" :xsmall="true" class="ml-1"
                                        @click="copyToClipboard(OnpublishServer)" />
                                    </v-col>
                                </v-row>
                            </th>
                            <th class="thead_custom_right thead_custom_top pa-3">
                                <span class="text_box">{{ OnpublishServer }}</span>
                            </th>
                        </tr>
                        <tr>
                            <th class="thead_custom_left pa-3">
                                <v-row>
                                    <v-col cols="8">
                                        <h4>StreamKey</h4>
                                    </v-col>
                                    <v-col cols="4">
                                        <TextButton buttonText="copy" :xsmall="true" class="ml-1"
                                        @click="copyToClipboard(stream_name)" />
                                    </v-col>
                                </v-row>
                            </th>
                            <th class="thead_custom_right pa-3">
                                <span class="text_box"> {{ stream_name }} </span>
                            </th>
                        </tr>
                        <tr>
                            <th class="thead_custom_left pa-3">
                                <v-row>
                                    <v-col cols="8">
                                        <h4>PLAYBACK URL</h4>
                                    </v-col>
                                    <v-col cols="4">
                                        <TextButton buttonText="copy" :xsmall="true" class="ml-1"
                                        @click="copyToClipboard(HLS)" />
                                    </v-col>
                                </v-row>
                            </th>
                            <th class="thead_custom_right pa-3">
                                <span class="text_box"> {{ HLS }}</span>
                            </th>
                        </tr>
                        <tr>
                            <th class="thead_custom_left pa-3">
                                <v-row>
                                    <v-col cols="8">
                                        <h4>EMBEDIED URL</h4>  
                                    </v-col>
                                    <v-col cols="4">
                                        <TextButton buttonText="copy" :xsmall="true" class="ml-1"
                                        @click="copyToClipboard(EMBEDIEDURL)" />
                                    </v-col>
                                </v-row>
                            </th>
                            <th class="thead_custom_right pa-3">
                                <span class="text_box">{{ EMBEDIEDURL }}</span>
                            </th>
                        </tr>
                        <tr>
                            <th class="thead_custom_left pa-3">
                                <v-row>
                                    <v-col cols="8">
                                        <h4>THUMBNAIL URL</h4>
                                    </v-col>
                                    <v-col cols="4">
                                        <TextButton buttonText="copy" :xsmall="true" class="ml-1"
                                        @click="copyToClipboard(ThumbnailUrl)" />
                                    </v-col>
                                </v-row>
                            </th>
                            <th class="thead_custom_right pa-3">
                                <span class="text_box"> {{ ThumbnailUrl }} </span>
                            </th>
                        </tr>
                    </thead>
                    </template>
                    </v-simple-table>
                </v-col>

            </v-row>

            </v-col>
        </v-row>
    </div>

</template>

<script>
import Input from '@/components/ui/form/FormInput.vue';
import TextButton from '@/components/ui/button/TextButton2.vue';
import CustomSwitch from '@/components/ui/switch/CustomSwitch.vue';
import IconButton from '@/components/ui/button/IconButton.vue';
import LiveStreamApi from "@/api/livestream/LiveStreamApi";
import { mapActions, mapState } from 'vuex';


export default {
    components: {
        Input,
        TextButton,
        CustomSwitch,
        IconButton,
    },
    data() {
        return {
            stream_name: '',
            //OnpublishServer: '',
            application: '',
            // switchStates: {
            //     publishing: false,
            //     recording: false,
            // },
            live_status: '',

        }
    },
    computed: {
        EMBEDIEDURL() {
            return `${window.location.protocol}//${window.location.host}/player?` + this.HLS;
        },
        HLS() {
            return 'https://' + this.cname + '/' + this.application + '/_definst_/' + this.stream_name + '/playlist.m3u8';
        },
        ThumbnailUrl() {
            return 'http://' + this.wowzaOrigin + ':8086/thumbnail?application=' + this.application + '&streamname=' + this.stream_name + '&size=640x360&fitmode=letterbox'
        },

        ...mapState('livestatus', {
            switchStates: state => state.switchStates
        }),
        isPublishing() {
            return this.switchStates ? this.switchStates.publishing : false;
        },
        isRecording() {
            return this.switchStates ? this.switchStates.recording : false;
        },
        //OnpublishServer = 'rtmp://' + this.wowzaOrigin + '/' + this.application + '/';
        OnpublishServer() {
            return 'rtmp://' + this.wowzaOrigin + '/' + this.application + '/';
        }
    },
    methods: {
        ...mapActions('livestatus', ['toggleSwitch', 'saveSettings']),
        async saveChanges() {
            const frontUrl = `${window.location.protocol}//${window.location.host}`;
            const uuid = this.$route.params.uuid;
            const data = {
                ip: frontUrl,
                uuid: uuid,
                publishing: this.switchStates ? this.switchStates.publishing : false,
                recording: this.switchStates ? this.switchStates.recording : false,
                stream_name: this.stream_name
            };
            //console.log('data', data);
            const success = await this.$store.dispatch('livestatus/saveSettings', data);
            if (success) {
                this.$emit('settingsSaved');
            }
        },
        copyToClipboard(textToCopy) {
            this.$copyText(textToCopy)
                .then(() => {

                })
                .catch(() => {
                    alert('Failed to copy text.');
                });
        },
        refreshIframe() {
            const originalURL = this.EMBEDIEDURL;
            this.$refs.iframe.src = '';
            this.$nextTick(() => {
                this.$refs.iframe.src = originalURL;
            });
        },
        async liveData(uuid) {
            try {
                const frontUrl = `${window.location.protocol}//${window.location.host}`;
                const data = {
                    ip: frontUrl,
                    uuid: uuid,
                };
                const response = await LiveStreamApi.detailApi(data);
                this.stream_name = response.item.stream_name;
                this.live_status = response.item.live_status;
                this.application = response.item.application;
                this.switchStates.publishing = response.item.pb_accept == '1';
                this.switchStates.recording = response.item.record_status == '1';
                this.cname = response.domain;

            } catch (error) {
                console.error('error', error);
            }
        },
        temp() {
            const iframe = this.$refs.iframe;
            const video = iframe.contentWindow.document.querySelector('video');
            if (!video) return;
            video.poster = "/streamon.png";
        },
        resizeVideo() {
            const iframe = this.$refs.iframe;
            const video = iframe.contentWindow.document.querySelector('video');
            const iframeDocument = iframe.contentWindow.document;
            if (!video) return;

            const container = iframe.parentElement;
            const containerWidth = container.offsetWidth;
            const videoWidth = video.videoWidth;
            const videoHeight = video.videoHeight;
            const aspectRatio = videoWidth / videoHeight;

            if (aspectRatio < 1) {
                container.style.paddingBottom = `${(videoHeight / videoWidth) * 100}%`;
            } else {
                container.style.paddingBottom = '56.25%';
            }

            video.autoplay = true;
            video.play();

        },
        refresh() {
            const uuid = this.$route.params.uuid;
            this.liveData(uuid);
        },
        async getApplication() {

            try {
                const response = await LiveStreamApi.getApplicationApi();
                //console.log('res', response.wowza);
                if (response.status === 1) {
                    //const applicationData = response.application;
                    //const wowzaData = response.data.data;
                    // const wowzaOrigin = response.wowza;

                    // this.application = applicationData;
                    //this.wowzaData = wowzaData;
                    this.wowzaOrigin = response.wowza;
                    // this.OnpublishServer = 'rtmp://' + this.wowzaOrigin + '/' + this.application + '/';
                } else {
                    console.error('Error:', response.message);
                }
            } catch (error) {
                console.error('Error:', error);
            }
        },
        toggleSwitch(switchKey) {
            this.switchStates[switchKey] = !this.switchStates[switchKey];
            //console.log(switchKey + " 스위치가 " + (this.switchStates[switchKey] ? '켜짐' : '꺼짐') + "으로 전환됨");
        }
    },
    async beforeMount() {
        const uuid = this.$route.params.uuid;
        await this.getApplication();
        await this.liveData(uuid);
    },
    watch: {
        live_status(newStatus) {
            //console.log("newStatus", newStatus);
            if (newStatus === 1) {
                this.refreshIframe();
            }
        }
    }
}
</script>

<style>
.cont_title {
    margin-top: 20px;
    padding-bottom: 10px;
    border-bottom: 1px solid #000;
    font-size: 18px;
}

.tabletitle {
    font-size: 18px;
    padding-bottom: 10px;
}

.live_left_wraper {width: 500px !important;}

@media only screen and (max-width: 600px) {
.lr_wrapper{
    display: block;
}
.right_wraper {
    margin:0px ;
}
}

.right_wraper {
    width: 100%;
    margin-left:20px ;
}

.text_box {
    word-break: break-all;
    color: #888;
    width: 100%;
}

.table_text {
    background: #fff;
}

iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
}

.video-container video {
    width: 100%;
    height: 100%;
    object-fit: contain;
}

.video-container {
    position: relative;
    background-color: black;
    width: 100%;
    height: 500px;
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    border-radius: 12px;
}

.thumbnail-wrapper {
    position: relative;
    width: 300px;
    height: 200px;
}

.thumbnail-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
}
</style>